import VIEW_BREAKPOINTS from '../../constants/view-breakpoints'

const getBreakpoint = (width = 0) => {
    if (width < VIEW_BREAKPOINTS.SM) {
        return VIEW_BREAKPOINTS.XS
    }
    if (width < VIEW_BREAKPOINTS.MD) {
        return VIEW_BREAKPOINTS.SM
    }
    if (width < VIEW_BREAKPOINTS.LG) {
        return VIEW_BREAKPOINTS.MD
    }
    if (width < VIEW_BREAKPOINTS.XL) {
        return VIEW_BREAKPOINTS.LG
    }
    return VIEW_BREAKPOINTS.XL
}

export default getBreakpoint